<template>
  <div class="aiben-tab">
    <div class="first-level">
      <div
        class="first-item-wrapper"
        v-for="(item, index) in functionContent"
        :key="index"
        @click="$emit('jumpLink', item.title)"
      >
        <div
          class="item-left"
          :style="{ backgroundImage: 'url(' + item.avtar + ')' }"
        ></div>
        <div class="item-right">
          <span>{{ item.title }}</span>
          <span>{{ item.content }}</span>
        </div>
      </div>
    </div>
    <div class="small-level">
      <div
        class="small-item-wrapper"
        v-for="(item, index) in vajraPosition"
        :key="index"
        @click="$emit('jumpLink',item.title)"
      >
        <img :src="item.icon" alt="" />
        <div class="title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tab",
  data() {
    return {
      functionContent: [
        {
          avtar: require("../../../assets/images/aiben/doctor.png"),
          title: "急速问诊",
          content: "名医在线问诊",
        },
        {
          avtar: require("../../../assets/images/aiben/eat.png"),
          title: "吃出健康",
          content: "健康饮食指南",
        },
      ],
      vajraPosition: [
        {
          icon: require("../../../assets/images/aiben/icon1.png"),
          title: "会员权益",
        },
        {
          icon: require("../../../assets/images/aiben/icon2.png"),
          title: "扫码积分",
        },
        {
          icon: require("../../../assets/images/aiben/icon3.png"),
          title: "正品溯源",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.aiben-tab {
  width: 351px;
  height: 188px;
  background: #ffffff;
  border-radius: 4px;
  margin: 0 auto 11px;
}
.first-level {
  padding: 12px 12px 4px;
  display: flex;
  :first-child{
    margin-right: 8px;
  }
  .first-item-wrapper {
    width: 160px;
    height: 80px;
    background: rgba(3, 110, 101, 0.05);
    border-radius: 1px;
    display: flex;
    align-items: center;
    .item-left {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      width: 50px;
      height: 50px;
      margin-left: 8px;
      margin-right: 4px;
    }
    .item-right {
      display: flex;
      flex-direction: column;
      color: #333333;

      :first-child {
        font-size: 18px;
        font-family: FZZZHONGJW--GB1-0, FZZZHONGJW--GB1;
        font-weight: 600;
        line-height: 22px;
        -webkit-background-clip: text;
        margin-bottom: 2px;
        // -webkit-text-fill-color: transparent;
      }
      :nth-child(2) {
        width: 72px;
        height: 16px;
        // font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }
}
.small-level {
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 92px;
  img {
    width: 44px;
    height: 44px;
    // margin-bottom: 2px;
    margin-left: 6px;
  }
  .title {
    // width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
}
</style>
